import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { ListActionContext } from "./ListActionContext";
import index from "@beeldit/core/services";
import { INCLUDED_INVOICE_TYPE_IDS } from "../../configs/constants";

function useIndex() {
  const { tableFilters, paginationConfig, orderBy, setTableData } =
    useContext(ListActionContext);
  const errorHandler = useErrorHandler();
  return () => {
    let filterPath = "relations=tenant,receiver_account,invoice_lines";
    // Mostrar solo facturas: si hay lista incluida, la aplicamos
    if (INCLUDED_INVOICE_TYPE_IDS && INCLUDED_INVOICE_TYPE_IDS.length > 0) {
      filterPath += `&invoice_type_id=${INCLUDED_INVOICE_TYPE_IDS.join(",")}`;
    }
    if (tableFilters) {
      for (const [key, value] of Object.entries(tableFilters)) {
        if (value) {
          filterPath += `&${key}=${value}`;
        }
      }
    }
    if (paginationConfig) {
      for (const [key, value] of Object.entries(paginationConfig)) {
        if (value && key !== "total_items") {
          filterPath += `&${key}=${value}`;
        }
      }
    }
    if (orderBy) {
      filterPath += `&orderBy=${orderBy}`;
    }
    index("invoices", filterPath)
      .then((response: any) => {
        setTableData(response.data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useIndex;
